define('OutSystems/ReactView/RouteComponents',["require", "exports", "tslib", "OutSystems/ClientRuntime/ApplicationInfo", "OutSystems/ClientRuntime/ErrorHandling", "react", "./HtmlTags"], function (require, exports, tslib_1, ApplicationInfo, ErrorHandling, React, HtmlTags_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createView = exports.NoDefaultScreen = exports.NotFoundScreen = exports.AbstractErrorComponent = void 0;
    var AbstractErrorComponent = (function (_super) {
        tslib_1.__extends(AbstractErrorComponent, _super);
        function AbstractErrorComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AbstractErrorComponent.prototype.getErrorMessage = function () {
            var errorPageConfig = ApplicationInfo.getErrorPageConfig();
            var defaultMessage = errorPageConfig && errorPageConfig.messages && errorPageConfig.messages.defaultMessage;
            return defaultMessage || "There was an error processing your request.";
        };
        AbstractErrorComponent.prototype.getExtraErrorMessage = function () {
            var errorPageConfig = ApplicationInfo.getErrorPageConfig();
            var extraMessage = errorPageConfig && errorPageConfig.extraMessage;
            return extraMessage || "";
        };
        AbstractErrorComponent.getCssDependencies = function () {
            return [];
        };
        AbstractErrorComponent.getJsDependencies = function () {
            return [];
        };
        AbstractErrorComponent.getBlocks = function () {
            return [];
        };
        AbstractErrorComponent.prototype.render = function () {
            return React.createElement(HtmlTags_1.HtmlTags.div);
        };
        AbstractErrorComponent.prototype.componentDidMount = function () {
            ErrorHandling.navigateToErrorPage(null, this.getErrorMessage(), this.getExtraErrorMessage());
        };
        return AbstractErrorComponent;
    }(React.Component));
    exports.AbstractErrorComponent = AbstractErrorComponent;
    var NotFoundScreen = (function (_super) {
        tslib_1.__extends(NotFoundScreen, _super);
        function NotFoundScreen() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        NotFoundScreen.prototype.getErrorMessage = function () {
            var errorPageConfig = ApplicationInfo.getErrorPageConfig();
            var notFoundMessage = errorPageConfig && errorPageConfig.messages && errorPageConfig.messages.screenNotFound;
            return notFoundMessage || "Screen not found: " + (this.props.location.pathname || "(none)");
        };
        return NotFoundScreen;
    }(AbstractErrorComponent));
    exports.NotFoundScreen = NotFoundScreen;
    var NoDefaultScreen = (function (_super) {
        tslib_1.__extends(NoDefaultScreen, _super);
        function NoDefaultScreen() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        NoDefaultScreen.prototype.getErrorMessage = function () {
            var errorPageConfig = ApplicationInfo.getErrorPageConfig();
            var noDefaultScreen = errorPageConfig && errorPageConfig.messages && errorPageConfig.messages.noDefaultScreen;
            return noDefaultScreen || "This module does not contain a default entry.";
        };
        return NoDefaultScreen;
    }(AbstractErrorComponent));
    exports.NoDefaultScreen = NoDefaultScreen;
    function createView(view, controller, model, cachedScreenState, shallSaveStateOnLeave) {
        return (function (_super) {
            tslib_1.__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.render = function () {
                var screenProperties = {
                    controller: controller,
                    model: model,
                    navigationKey: this.props.location.key,
                    cachedScreenState: cachedScreenState,
                    shallSaveStateOnLeave: shallSaveStateOnLeave,
                };
                return React.createElement(view, screenProperties);
            };
            return class_1;
        }(React.Component));
    }
    exports.createView = createView;
});
//# sourceMappingURL=RouteComponents.js.map;
